import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";

export interface LinkedInInmailBalanceParams {
  accountId: string;
}

function isRef<T>(param: Ref<T> | T): param is Ref<T> {
  return typeof param === "object" && param !== null && "value" in param;
}

export function useLinkedInInmailBalance(
  params: Ref<LinkedInInmailBalanceParams | null> | LinkedInInmailBalanceParams | null
) {
  const queryKey = computed(() => {
    const p = isRef(params) ? params.value : params;
    if (!p) return ["linkedin-inmail-balance", "disabled"];
    return ["linkedin-inmail-balance", p.accountId];
  });

  const enabled = computed(() => {
    const p = isRef(params) ? params.value : params;
    return p !== null && p !== undefined && !!p.accountId;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = isRef(params) ? params.value : params;
      if (!p) throw new Error("Parameters not ready");

      const response = await Unipile.getInmailBalance(p.accountId);

      if (response.data?.status) {
        return response.data.data;
      }

      throw new Error("Failed to load LinkedIn InMail balance");
    },
    enabled,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
